import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["selectElement"];

  connect() {
    this.blockId = this.element.dataset.blockId;
    this.blockType = 'select';
  }

  save(event) {
    if (event && event.isChannelUpdate) {
      return;
    }
    
    window.activeEditingManager.startEditing(this.blockId, this.blockType, this.element);
    
    const selectElement = this.selectElementTarget;

    if (!selectElement) {
      console.error("selectElement target not found!");
      return;
    }

    const newValue = selectElement.value.trim();
    if (!newValue) return;

    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ 
        task_block: { value: newValue },
        skip_broadcast: false // Always broadcast - the channel will skip updates for the editing user
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("Select value saved:", data.value);
          // Stop editing after successful save
          window.activeEditingManager.stopEditing(this.blockId, 500);
        } else {
          console.error("Failed to save select value:", data);
          // Stop editing even on error
          window.activeEditingManager.stopEditing(this.blockId, 1000);
        }
      })
      .catch(error => {
        console.error("Error saving select value:", error);
        // Stop editing on error
        window.activeEditingManager.stopEditing(this.blockId, 1000);
      });
  }

  disconnect() {
    // Clean up editing state when controller disconnects
    if (this.blockId) {
      window.activeEditingManager.stopEditing(this.blockId, 0); // No debounce on disconnect
    }
  }
}
